import { Col } from "@/atoms"
import { ANALYTIC_EVENTS } from "@/const/event.constants"
import { useTranslation } from "@/hooks/useTranslation"
import { FixesLocationCard } from "@/molecules/FixesLocationCard"
import { useCopyable } from "@/organisms/Drawers/components/TriageDrawer/hooks/useCopyable"

import type {
  ExposedSecretFinding,
  VulnerableCodeFinding
} from "@/domain/issue"
import type { VulnerableCodeCardsProps } from "."

export const VulnerableCodeCards = (props: VulnerableCodeCardsProps) => {
  const { findings } = props.record || {}
  const recordFinding = findings?.[0] as
    | VulnerableCodeFinding
    | ExposedSecretFinding
    | undefined
  const { t } = useTranslation()
  const tKey = "inventory.images.drawer.issue."
  const elementId = "VulnerableCodeCardsComponent"
  const onCopy = useCopyable(elementId, recordFinding?.issueType, {
    mixpanelEvent: ANALYTIC_EVENTS.TRIAGE.DRAWER.COPY_MANUAL_HOW_TO_FIX,
    onFindNode: (node) => {
      node
        .querySelectorAll(
          '[data-component-id="title-card-fixes-description"], button'
        )
        .forEach((el) => el.remove())
    }
  })

  return (
    <>
      <Col
        id={elementId}
        span={24}
        data-element-issue-expandable-cell-view="fix-container"
      >
        <FixesLocationCard t={t} tKey={tKey} onCopy={onCopy} {...props} />
      </Col>
    </>
  )
}
